import React from 'react';

import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, Box, xcss } from '@atlaskit/primitives';

// Keep this style same as the wrapper in HelpManager.tsx except `color` since it's unneeded
const wrapperStyles = xcss({
	position: 'absolute',
	bottom: 'space.300',
	left: 'space.250',
	zIndex: 'layer',
	cursor: 'pointer',
});

// To match button styling that's in the original HelpManager
const iconWrapperStyles = xcss({
	height: '32px',
	width: '32px',
});

export const HelpManagerPlaceholder = () => {
	return (
		<Box xcss={wrapperStyles} testId="help-manager-placeholder">
			<Flex xcss={iconWrapperStyles} alignItems="center" justifyContent="center">
				<QuestionCircleIcon color="var(--ds-text-subtle)" label="" />
			</Flex>
		</Box>
	);
};
